module.exports = __webpack_public_path__ + "static/logo-5d68a9703e9bbcb6bcc0f2955dc5e8b6.svg";